import { DocumentTypes, UploadedDocument } from '@urbanx/agx-ui-components';
import { useAppSelector } from 'hooks/useAppSelector';
import FileUpload from '../FileUpload/FileUpload';

interface AttachAsFileProps {
  id: string;
  defaultValue?: UploadedDocument;
  documentType?: DocumentTypes;
  onValueChanged: (value: { id: string; value?: UploadedDocument }) => void;
  validate?: boolean;
}

const AttachAsFile = ({
  id,
  defaultValue,
  documentType,
  onValueChanged,
}: AttachAsFileProps) => {
  const { campaignId } = useAppSelector(state => state.form);

  return (
    <>
      <FileUpload
        key={`${id}-fileUpload`}
        id={`${id}-fileUpload`}
        documentType={documentType ?? DocumentTypes.Miscellaneous}
        extensions={['pdf']}
        fileData={defaultValue}
        campaignId={campaignId}
        onValueChanged={({ value }) =>
          onValueChanged({
            id,
            value: value && value.length > 0 ? value[0] : undefined,
          })
        }
        multiple={false}
        required
        validate={undefined}
      />
    </>
  );
};

export default AttachAsFile;
